import { State } from 'containers/desktop/Reports/State';
import { useHandler } from 'hooks/useHandler';

export default function useState() {
	const [state, rf] = useHandler<State.Type>(State.create());
	return {
		state,
		handlers: {
			setReportGroups: rf.createReducer(State.setReportGroups),
			setIsDragOver: rf.createReducer(State.setIsDragOver),
			setIsLoading: rf.createReducer(State.setIsLoading),
			setSearch: rf.createReducer(State.setSearch),
			setStatus: rf.createReducer(State.setStatus),
			setPage: rf.createReducer(State.setPage),
			setTotalReports: rf.createReducer(State.setTotalReports),
			setSelectedMonth: rf.createReducer(State.setSelectedMonth),
			setFilterMonth: rf.createReducer(State.setFilterMonth),
		},
	};
}

export type Handlers = ReturnType<typeof useState>['handlers'];
